import areasGeograficas from './areasGeograficas'
import empresas from './empresas'
import geo from './geo'
import menu from './menu'
import motoristas from './motoristas'
import rastreadores from './rastreadores'
import usuarios from './usuarios'
import validadores from './validadores'
import veiculos from './veiculos'

const WS_CADASTRO = {
  menu,
  validadores,
  empresas,
  motoristas,
  veiculos,
  usuarios,
  rastreadores,
  areasGeograficas,
  geo,
}

export default WS_CADASTRO
